var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91553 10.3881C1.91553 9.92519 1.91553 9.69375 1.93547 9.49882C2.12783 7.6187 3.66366 6.13137 5.60508 5.94509C5.80637 5.92578 6.05825 5.92578 6.56201 5.92578C6.75612 5.92578 6.85318 5.92578 6.93558 5.92094C7.98782 5.85923 8.90924 5.21608 9.30244 4.26888C9.33323 4.1947 9.36202 4.11108 9.41958 3.94385C9.47714 3.77661 9.50593 3.69299 9.53672 3.61881C9.92992 2.67161 10.8513 2.02846 11.9036 1.96675C11.986 1.96191 12.077 1.96191 12.259 1.96191H18.8595C19.0415 1.96191 19.1325 1.96191 19.2149 1.96675C20.2672 2.02846 21.1886 2.67161 21.5818 3.61881C21.6126 3.69299 21.6414 3.77661 21.6989 3.94385C21.7565 4.11108 21.7853 4.1947 21.8161 4.26888C22.2093 5.21608 23.1307 5.85923 24.1829 5.92094C24.2653 5.92578 24.3624 5.92578 24.5565 5.92578C25.0603 5.92578 25.3121 5.92578 25.5134 5.94509C27.4549 6.13137 28.9907 7.6187 29.183 9.49882C29.203 9.69375 29.203 9.92519 29.203 10.3881V20.7242C29.203 22.9442 29.203 24.0542 28.7569 24.9021C28.3644 25.6479 27.7383 26.2543 26.9681 26.6343C26.0925 27.0664 24.9464 27.0664 22.654 27.0664H8.46452C6.17216 27.0664 5.02598 27.0664 4.15041 26.6343C3.38024 26.2543 2.75407 25.6479 2.36165 24.9021C1.91553 24.0542 1.91553 22.9442 1.91553 20.7242V10.3881Z",
    stroke: "currentColor",
    strokeWidth: 2.183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5593 21.1206C18.5733 21.1206 21.0168 18.7543 21.0168 15.8354C21.0168 12.9165 18.5733 10.5503 15.5593 10.5503C12.5452 10.5503 10.1018 12.9165 10.1018 15.8354C10.1018 18.7543 12.5452 21.1206 15.5593 21.1206Z",
    stroke: "currentColor",
    strokeWidth: 2.183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon_camera.f318dc68.svg";
export { ForwardRef as ReactComponent };